import Vue from 'vue';
import Router from 'vue-router';
import menu from './menu';
import {
  SOURCE
} from '@lib/config.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'ui-router-active',
  // scrollBehavior: () => ({ y: 0 }),
  // 只在 HTML5 history 模式下可用
  scrollBehavior: (to, from, savedPosition) => {
    to.matched.some(m => {
      // console.log(m);
    });
    return {
      y: 0
    };
  },
  routes: [{
      path: '/',
      redirect: (to) => {
        if (SOURCE != 'esign') {
          window.location.href = `yonyou.html`;
        } else {
          return { path: '/main/index' };
        }
      }
      // beforeEnter: (to, from, next) => {}
    },
    {
      name: 'Login',
      path: '/login',
      meta: {},
      component: function (resolve) {
        require(['../views/login/login.vue'], resolve);
      }
    },
    ...generateRoutesFromMenu(menu),
    {
      path: '*',
      redirect: to => {
        // window.location.href = "404.vue"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach, 异步组件还没有加载', to);
  // console.log(to, 'to');
  // console.log(from, 'from');
  next();
});

router.beforeResolve((to, from, next) => {
  // console.log('router.beforeResolve-此时异步组件已经加载完成');
  // console.log('router.beforeResolve');
  // console.log(to, 'to.beforeResolve');
  // console.log(from, 'from.beforeResolve');
  next();
});

router.afterEach((to, from, next) => {
  // console.log('router.afterEach');
});

// *** 遍历
function generateRoutesFromMenu(menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

export default router;



// WEBPACK FOOTER //
// ./src/pages/admin/router/index.js